import "reflect-metadata";
import {inject, injectable} from "inversify";
import {ClientRepository} from "@dropDesk/domain/repositories/client/client.repository";
import {ImportData} from "@dropDesk/domain/entities/import_data/import_data";

@injectable()
export class ImportClientUseCase {
  private _repository: ClientRepository;

  constructor(@inject(ClientRepository) repository: ClientRepository) {
    this._repository = repository;
  }

  public call(file: File, id?: string): Promise<ImportData> {
    return this._repository.import(file, id);
  }
}

